<script setup>
import Card from '@/Components/Card/Card.vue';
import SiteLayout from '@/Layouts/Layout.vue';
import Tab from '@/Components/Tab/Tab.vue';
import TabItem from '@/Components/Tab/TabItem.vue';
import { reactive } from 'vue';
import IpAddressForm from '@/Pages/CidrCalculator/Partials/IpAddressForm.vue';
import CidrToIpForm from '@/Pages/CidrCalculator/Partials/CidrToIpForm.vue';
import IpToCidrForm from '@/Pages/CidrCalculator/Partials/IpToCidrForm.vue';

const state = reactive({
  tab: 1
});
</script>

<template>
  <SiteLayout
    :title="$t('cidr_calculator.index.cidr_calculator_subnet_ip')"
    :description="$t('cidr_calculator.index.cidr_calculator_description')"
  >
    <Card>
      <div
        class="flex flex-1 flex-col flex-wrap gap-4 md:flex-row md:items-start"
      >
        <div>
          <div class="mb-1">{{ $t('cidr_calculator.index.check') }}</div>
          <Tab contained>
            <TabItem
              :active="state.tab === 1"
              :title="$t('cidr_calculator.index.ip_address')"
              @click.prevent="state.tab = 1"
            />
            <TabItem
              :active="state.tab === 2"
              :title="$t('cidr_calculator.index.cidr_to_ip_range')"
              @click.prevent="state.tab = 2"
            />
            <TabItem
              :active="state.tab === 3"
              :title="$t('cidr_calculator.index.ip_range_to_cidr')"
              @click.prevent="state.tab = 3"
            />
          </Tab>
        </div>
        <IpAddressForm v-if="state.tab === 1" />
        <CidrToIpForm v-if="state.tab === 2" />
        <IpToCidrForm v-if="state.tab === 3" />
      </div>
    </Card>
    <section id="results" />
  </SiteLayout>
</template>
